
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import ProgressMobileStepper from './ProgressMobileStepper';
import { IconLeftArrow } from '../../../../../components/buttons/IconButtons';
import CustomMenuLanguage from '../../../../../components/Language/CustomMenuLanguage';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param showBtnBack
 * @param click Click event for the back navigation button
 * @param url  URL to navigate back
 * @param activeStep Active or current step being viewed
 * @param steps  Total number of steps to be displayed in the form
 * @param headerCenter JSX content that goes in the center of the page header
 *
 */
const HeaderValidation = (
    {
        showBtnBack = true,
        click = null,
        url = '',
        activeStep = null,
        steps = null,
        headerCenter = null
    }
) => {
    const navigate = useNavigate();

    const [isSelected, setIsSelected] = useState(false);
    const [isPressing, setIsPressing] = useState(false);

    const handleClick = (click, url) => {
        if (click != null) click();
        if (url !== '') navigate(url);
    }

    let activeClass = '';
    if (isSelected) {
        activeClass = 'active-selected';
    } else if (isPressing) {
        activeClass = 'active-pressing';
    }
    return (
        <div className="identity-validation-external-header">
            <div className="d-flex flex-column w-100">

                <div className="d-flex justify-content-between align-items-center">
                    {showBtnBack ?
                        <>
                            <div className="d-block d-md-none">
                                <div className={`btn-selected-pressing ${activeClass}`}>
                                    <IconLeftArrow
                                        onTouchStart={() => setIsSelected(true)}
                                        onTouchEnd={() => setIsSelected(false)}
                                        onMouseDown={() => setIsPressing(true)}
                                        onMouseUp={() => setIsPressing(false)}
                                        onClick={() => {
                                            handleClick(click, url);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="d-none d-md-block">
                                <ButtonAction
                                    id='btn_iv_back_validation'
                                    name='back'
                                    className='btn-outlined-secondary-600-00'
                                    disabled={false}
                                    splitName={false}
                                    Icon={IconLeftArrow}
                                    onClick={() => {
                                        handleClick(click, url);
                                    }}
                                />
                            </div>
                        </>
                        : <div/>
                    }

                    {headerCenter &&
                        <>
                            {headerCenter}
                        </>
                    }

                    <div>
                        <CustomMenuLanguage />
                    </div>
                </div>

                {activeStep != null && steps != null &&
                    <div className="w-100 p-0 m-0">
                        <ProgressMobileStepper activeStep={activeStep} steps={steps} />
                    </div>
                }

            </div>
        </div>
    )

}

export default HeaderValidation
